import React, { useEffect } from 'react';
import { FaLink } from 'react-icons/fa';
import s from '../../global.css';
const NotFound = () => {
    useEffect(() => {
        document.title = 'Sticknet | Not found';
    }, []);
    const isDesktop = window.innerWidth > window.innerHeight;
    return (React.createElement("div", { className: s.main },
        React.createElement("div", { className: s.body, style: {
                height: '80vh',
                justifyContent: 'center',
                alignItems: 'center',
                paddingTop: '30vh',
            } },
            React.createElement(FaLink, { style: { fontSize: isDesktop ? '5vw' : '20vw', textAlign: 'center' } }),
            React.createElement("h1", { style: { padding: '3vw', paddingBottom: '1vw' } }, "404 Not Found"),
            React.createElement("p", null, "The page you're looking for does not exist..."))));
};
export default NotFound;
